import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=658be378&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"
import style0 from "./BasePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports